import { useForm, UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { ImportContributionsForm } from 'services/requests';

export const useImportContributionsForm = (): UseFormReturn<ImportContributionsForm> => {
  const schema: yup.SchemaOf<ImportContributionsForm> = yup.object({
    file: yup.mixed<FileList>(),
  });

  return useForm<ImportContributionsForm>({
    mode: 'all',
    reValidateMode: 'onBlur',
    defaultValues: {
      file: undefined,
    },
    resolver: yupResolver(schema),
  });
};
